<template>
  <section class="contact-customer">
    <!--    <span class="label">Contact Customer</span>-->
    <div class="btn-list flex">
      <v-button
        icon="phone"
        @click="handleCall"
      >
      </v-button>

      <v-button
        @click="handlerContact(1)">
        <font-awesome-icon icon="sms"></font-awesome-icon>
      </v-button>


      <v-button
        @click="handlerContact(2)"
      >
        <font-awesome-icon :icon="['fab','whatsapp']"></font-awesome-icon>
      </v-button>
      <v-button
        :disabled="!customerId"
        @click="handlerContact(0)">
        <font-awesome-icon icon="bell"></font-awesome-icon>
      </v-button>
      <v-button
        @click="handlerContact(3)">
        <font-awesome-icon icon="envelope"></font-awesome-icon>
      </v-button>
    </div>
    <contact-dialog
      ref="contact-dialog"
      :type="contactType"
      :ticketId="ticketId"
      :initPhone="phone"
      :initEmail="email"
      :is-enquiry="isEnquiry"
      :is-policy="isPolicy"
      :is-quote="isQuote"
      :customerData="customerData"
      :is-input="isInput"
      :is-ticket="isTicket"
      :initCustomerName="customerName"
      :initCustomerId="customerId"
      @success="handlerSuccess" />
  </section>

</template>
<script>
import ContactDialog from '@/views/tickets/dialogs/contact-dialog'

export default {
  name: 'ContactCustomer',
  components: {
    ContactDialog
  },
  props: {
    ticketId: {
      type: [String, Number],
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    customerId: {
      type: [String, Number],
      default: ''
    },
    customerName:{
      type: String,
      default: ''
    },
    isEnquiry: {
      type: Boolean,
      default: false
    },
    isPolicy: {
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    isTicket: {
      type: Boolean,
      default: false
    },
    isInput: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      contactType: 0
    }
  },
  computed:{
    customerData(){
      return{
        contact_phone:this.phone,
        contact_email:this.email
      }
    }
  },
  methods: {
    handlerContact(type) {
      this.contactType = type
      this.$refs['contact-dialog'].changeDialog()
    },
    handlerSuccess() {
      this.$emit('success')
    },
    handleCall(){
      const elink = document.createElement('a')
      elink.style.display = 'none'
      elink.href = 'tel:' + this.phone
      document.body.appendChild(elink)
      elink.click()
      window.URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-list {
  .el-button {
    display: block;
    background-color: #FAFBFC;
    //margin: 0 0 5px 0;
    padding: 6px 14px;
    font-size: 14px;
  }


}
.label {
  display: inline-block;
  margin: 0 0 5px 0;
  font-size: 14px;
  font-weight: bold;
}
</style>
